import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from '@mui/material';
import IdInput from 'components/IdInput/IdInput';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { dialogState, projectState } from 'state';
import { RoutePaths, SupportedIdentifiers } from 'types/types';
import { getRoutePath } from 'utils';

import * as yup from 'yup';

export function AddPatientDialog() {
  const closeDialog = useSetRecoilState(dialogState);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { selectedProject } = useRecoilValue(projectState);

  const formik = useFormik({
    initialValues: {
      id: '',
      type: SupportedIdentifiers.taj,
    },

    validationSchema: yup.object({
      id: yup.string().when('type', {
        is: (type: string) => type === SupportedIdentifiers.taj,
        then: () =>
          yup
            .string()
            // @ts-ignore
            .isTajNumber(t('general.errors.hasToBeValidTAJ')),
      }),
    }),

    onSubmit: async values => {
      closeDialog({ isOpen: false });
      const basePath = getRoutePath(RoutePaths.patientCreator, {
        projectId: selectedProject?.id,
      });
      // adds idType and idNumber to the url
      navigate(basePath + `?idType=${values.type}&idNumber=${values.id}`);
    },
  });

  return (
    <Box>
      <DialogTitle>{t('dialogs.addPatient.title')}</DialogTitle>
      <DialogContent>
        <form>
          <IdInput
            value={{
              id: formik.values.id,
              type: formik.values.type,
            }}
            onChange={({ id, type }) => {
              formik.setFieldValue(`id`, id);
              type !== formik.values.type && formik.setFieldValue(`type`, type);
            }}
            error={Boolean(formik.errors.id)}
            helperText={t('general.errors.hasToBeValidTAJ') ?? ''}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => closeDialog({ isOpen: false })}
          color="secondary"
          variant="contained"
          sx={{ mb: 1 }}
        >
          {t('general.cancel')}
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          sx={{ mr: 2, mb: 1 }}
          disabled={
            formik.values.type === SupportedIdentifiers.taj ||
            formik.values.type === SupportedIdentifiers.other
              ? formik.values.id === '' || Object.keys(formik.errors).length > 0
              : false
          }
          onClick={() => formik.handleSubmit()}
        >
          {t('general.create')}
        </Button>
      </DialogActions>
    </Box>
  );
}
